import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useDashboardNotifications = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)

    try {
      const { data } = await RequestService.getDashboardNotifications()

      setData(data)
    } catch (e) {
      console.log('useDashboardNotifications', e)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data }
}

export default useDashboardNotifications
